"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      visible: false,
      form: {
        page: 1,
        limit: 50
      },
      date: [],
      rules: {
        page: {
          required: true,
          trigger: "submit",
          message: "Vui lòng nhập số trang"
        },
        limit: {
          required: true,
          trigger: "submit",
          message: "Vui lòng nhập số bản ghi muốn xuất"
        }
      },
      datePicker: {
        minDate: null,
        maxDate: null
      },
      pickerOptions: {
        disabledDate: this.disabledDueDate,
        onPick: this.handleChangeDatePicker
      }
    };
  },
  methods: {
    handleOpen: function handleOpen(page, limit, date) {
      this.form.page = page;
      this.form.limit = limit;
      this.date = date.map(function (item) {
        return (0, _moment.default)(item).format("YYYY-MM-DD HH:mm");
      });
      this.visible = true;
      this.$refs["form"].clearValidate();
    },
    handleExport: function handleExport() {
      var _this = this;
      this.$refs["form"].validate(function (valid) {
        if (valid && _this.form.limit <= 5000) {
          _this.$emit("export", {
            page: _this.form.page,
            limit: _this.form.limit,
            from: _this.date ? (0, _moment.default)(_this.date[0]).format("YYYY-MM-DD HH:mm:ss") : undefined,
            to: _this.date ? (0, _moment.default)(_this.date[1]).format("YYYY-MM-DD HH:mm:ss") : undefined
          });
        } else if (_this.form.limit > 5000) {
          _this.$message({
            message: "Bạn đã nhập quá 5000 bản ghi. Vui lòng kiểm tra lại",
            type: "info"
            // showClose: true,
            // duration: 3000,
          });
        }
      });
    },
    disabledDueDate: function disabledDueDate(time) {
      if (this.datePicker.minDate) {
        var past60days = (0, _moment.default)(this.datePicker.minDate).subtract(60, "days").valueOf();
        var next60days = (0, _moment.default)(this.datePicker.minDate).add(60, "days").valueOf();
        return time.getTime() < past60days || time.getTime() > next60days;
      }
      return false;
    },
    handleChangeDatePicker: function handleChangeDatePicker(date) {
      this.datePicker = date;
    }
  }
};